import React, { FC } from 'react';
import './PermissionForm.css';
import {
	useBreakPoint,
	DomainFormProps,
} from '@/Shared';

import PermissionTableForm from './PermissionTableForm';
import PermissionFormCardList from './PermissionFormCardList';


/**
 * =====================================================
 * Component: PermissionForm
 * =====================================================
 *
 *
 * Domain-specific form UI for Permission.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render permission fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const PermissionForm: FC<DomainFormProps> = ({
	domainFormHook,
	formRef,
	formikProps,

}) => {

	const { values, setFieldValue } = formikProps;
	const { entityFormVM, uiFeedbackHooks } = domainFormHook;
	const { lightBoxHook, confirmHook } = uiFeedbackHooks;
	const { isDesktop } = useBreakPoint();

	/**
	 * =====================================================
	 * Main Form Rendering
	 * =====================================================
	 *
	 * Fieldsets organize the form into logical sections for clarity.
	 */
	return isDesktop
		? <PermissionTableForm
			entityFormVM={entityFormVM}
			values={values}
			setFieldValue={setFieldValue}
		/>
		: <PermissionFormCardList
			entityFormVM={entityFormVM}
			values={values}
			setFieldValue={setFieldValue}
		/>;
}
export default PermissionForm;